console.log("site-child.js");

// css
import "../scss/style.scss";
//import '../scss/woocommerce/scss/woocommerce.scss'

// page builder framework theme js
import "./modules/page-builder-framework.js";

// slick carousel
import slick from "slick-carousel";

import slickSlider from "./modules/slick-slider.js";
var slider = new slickSlider();

//import carouselSliderRelated from './modules/slick-carousel-related.js';
//var carouselRelated = new carouselSliderRelated();

/*
import carouselSlider from './modules/slick-carousel.js';
var carousel = new carouselSlider();
import carouselSliderProducts from './modules/slick-carousel-products.js';
var carouselProduct = new carouselSliderProducts();
import carouselSliderProductsRow from './modules/slick-carousel-products-row.js';
var carouselRow = new carouselSliderProductsRow();
*/

// non va tramite modulo es6
/*
import carouselSliderGallery from './modules/slick-carousel-gallery.js';
var carouselGallery = new carouselSliderGallery();
*/

// cookie consent js
//console.log("cookieconsent.min.js");
//import './modules/cookieconsent.min.js';

(function ($) {
  // Add your custom scripts here.
  // This file will be compiled and is part of the gulp workflow.
  // If you're not using gulp, please make your changes directly to the site-child.js file in the main js folder.

  //SHOW SHIPPING PLUGIN GIFT AFTER SCROLLING
  $(document).scroll(function () {
    var y = $(this).scrollTop();
    if (y > 200) {
      $(".wfspb-gift-box").addClass("on");
    } else {
      $(".wfspb-gift-box").removeClass("on");
    }
  });

  $(document).ready(function () {
    //THUMBS GALLERY SLIDER
    $(".flex-control-nav").slick({
      autoplay: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      infinite: true,
    });

    //TOOGLE FILTRO
    $(".filtro-toggle").click(function (e) {
      e.preventDefault();

      $(".filtro").toggleClass("active");
      $(".filtro-toggle").toggleClass("close");
    });
  });

  //PW_CC COOKIECONSENT

  var cc_main_id = "#termsfeed-com---nb"; // id container
  var cc_accept_all = "button.cc-nb-okagree"; // identificatore bottone "accetta tutti"
  var cc_reject_all = "button.cc-nb-reject"; // identificatore bottone "rifiuta tutti"
  var cc_change_settings = "button.cc-nb-changep"; // identificatore bottone di cambio scelte
  var cc_custom_accept = "button.cc-cp-foot-save"; // identificatore bottone di salvataggio scelte personalizzate
  var cc_change_settings_footer = "#open_preferences_center";
  var cookie_name = "pw_cookieconsent";

  // oggetto contenente le impostazioni custom che è possibile modificare
  var custom_settings = {
    "strictly-necessary": true,
    functionality: true,
    tracking: true,
    targeting: true,
  };

  $(document).ready(function () {
    if (
      $(cc_main_id).length > 0 &&
      $(cc_change_settings).length > 0 &&
      $(cc_accept_all).length > 0
    ) {
      // se esiste il container e i vari bottoni (in pratica se Cookie Consent è stato caricato)...

      $(cc_accept_all).on("click", function (ee) {
        // quando clicco su "accetta tutti"
        save_choices(custom_settings);
      });

      $(cc_reject_all).on("click", function (ee) {
        // quando clicco su "rifiuta tutti"
        $.each(custom_settings, function (item, value) {
          // ...imposto tutte le scelte a false...
          custom_settings[item] = false;
        });
        save_choices(custom_settings);
      });

      $(cc_change_settings).on("click", function (ee) {
        // se si fa click su "Cambia le impostazioni"...
        if ($(cc_custom_accept).length > 0) {
          // ...e se esiste il bottone di salvataggio...
          $(cc_custom_accept).on("click", function (ee) {
            // ...al click del bottone di salvataggio...
            $.each(custom_settings, function (item, value) {
              // ...verifico tutte le impostazioni custom se sono selezionate o meno...
              custom_settings[item] = $("#" + item).is(":checked");
            });

            save_choices(custom_settings);
          });
        }
      });
    }

    if ($(cc_change_settings_footer).length > 0) {
      $(cc_change_settings_footer).on("click", function (ee) {
        // se si fa click su "Cambia le impostazioni"...
        if ($(cc_custom_accept).length > 0) {
          // ...e se esiste il bottone di salvataggio...
          $(cc_custom_accept).on("click", function (ee) {
            // ...al click del bottone di salvataggio...
            $.each(custom_settings, function (item, value) {
              // ...verifico tutte le impostazioni custom se sono selezionate o meno...
              custom_settings[item] = $("#" + item).is(":checked");
            });

            save_choices(custom_settings);
          });
        }
      });
    }
  });

  function save_choices(custom_settings) {
    var cookie_id = getCookie(cookie_name);

    $.ajax({
      url: "/pw_cookieconsent/pw_cc_ajax.php",
      type: "POST",
      data: {
        act: "save_choices",
        settings: custom_settings,
        cookie_id: cookie_id,
        url: window.location.href,
      },
      dataType: "json",
      success: function (data) {
        if (data.cookie_id != "") {
          setCookie(cookie_name, data.cookie_id, 60);
        }
      },
      error: function (request, error) {
        console.log("Request: " + JSON.stringify(request));
      },
    });
  }
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
})(jQuery);
